// resources/_default/frontend/src/scripts.js
/* This script will initialize all the custom scripts for the frontend */

module.exports = [
    //common
    //mixins
    //pages
    //utils
];